import { Button } from '@flix/common/elements/controls'
import { Image } from '@flix/common/elements/images/Image/Image'
import payPalLogo from './paypal-logo.png'

export const PayPalFakeButton = (props) => {
  return (
    <Button variant="grayLighter" {...props}>
      <Image source={payPalLogo} width={85} height={19} />
    </Button>
  )
}
